import React from 'react'

import type { IRowProps } from '../../Node/types'
import * as s from './PreviewRow.module.scss'

const PreviewRow: React.FC<IRowProps> = ({ children, style }) => {
  return (
    <div className={s.row} style={style}>
      {children}
    </div>
  )
}

export default PreviewRow
